<template>
  <div class="search_college">
    <div class="nav">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="nav_">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>智能查询</el-breadcrumb-item>
        <el-breadcrumb-item>提前批</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="tabs">

      <!--            所属地区-->
      <el-row class="search_line">
        <el-col :span="5"><span class="title">艺术体育类></span></el-col>
        <el-col :span="19">
          <span v-for="(item, i) in art_type1" :key="i" :class="{ act: check.type == item.id }"
            @click="chooseType(item.id, 0)">{{ item.name }}</span>
        </el-col>
      </el-row>
      <!--            院校类型-->
      <el-row class="search_line">
        <el-col :span="5"><span class="title">军队公安司法类></span></el-col>
        <el-col :span="19">
          <span v-for="(item, i) in art_type2" :key="i" :class="{ act: check.type == item.id }"
            @click="chooseType(item.id, 1)">{{ item.name }}</span>
        </el-col>
      </el-row>

      <!-- 招生批次 -->

      <el-row class="search_line">
        <el-col :span="5">
          <span class="title">专项其他类></span>
        </el-col>
        <el-col :span="19">
          <span v-for="(item, i) in art_type3" :key="i" :class="{
            act: check.type == item.id
          }" @click="chooseType(item.id, 2)">{{ item.name }}
          </span>
        </el-col>
      </el-row>
      <el-row class="search_line" v-if="nav_act">
        <el-col :span="5">
          <span class="title">分数类型</span>
        </el-col>
        <el-col :span="19">
          <span v-for="(item, i) in art_type" :key="i" :class="{ act: check.state == item.id }"
            @click="chooseBatch(item.id)">
            {{ item.name }}
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

export default {
  name: "ConditionalSearch",
  data() {
    return {
      check: {
        type: 10,
        state: 0,
        nav: 0
      },
      nav_act: null,
      art_type1: [
        {
          id: 10,
          name: "体育类",
        },
        {
          id: 11,
          name: "美术与设计类",
        },
        {
          id: 12,
          name: "舞蹈类",
        },

        {
          id: 13,
          name: "播音与主持类",
        },
        {
          id: 14,
          name: "表演类",
        },
        {
          id: 15,
          name: "书法类",
        },
        // {
        //   id: "22",
        //   name: "省级联考",
        // },
      ],
      art_type2: [
        // {
        //   id: 1,
        //   name: "军队院校招飞",
        // },
        {
          id: 2,
          name: "军队院校",
        },
        {
          id: 3,
          name: "公安院校",
        },
        {
          id: 4,
          name: "司法院校",
        },
      ],
      art_type3: [
        {
          id: 5,
          name: "地方公费师范生",
        },
        {
          id: 9,
          name: "国家公费师范生",
        },
        {
          id: 6,
          name: "国家专项",
        },
        {
          id: 7,
          name: "地方专项",
        },
        {
          id: 8,
          name: "其他类",
        },
      ],
      art_type: [{
        id: 0,
        name: '录取分'
      },
      {
        id: 1,
        name: '面试线'
      }],
      batch_list: [0, 1]
    };
  },
  created() {
  },
  methods: {
    chooseType(value, key) {
      this.check.type = value;
      this.check.state = 0;
      this.check.nav = key;
      if (key == 1) {
        this.nav_act = true
      } else {
        this.nav_act = false
      }
      this.$emit("onSearch", this.check);
    },
    chooseBatch(value) {
      this.check.state = value;
      this.$emit("onSearch", this.check);
    },
  },
};
</script>
<style lang="less">
.search_line {
  border-bottom: 1px solid #dfdfdf;
  padding: 10px 0;
}

.search_line:last-child {
  border: 0;
}
</style>
<style lang="less" scoped>
.nav {
  margin: 20px auto;

  .nav_ {
    width: 75%;
    display: inline-block;
  }

  .search {
    width: 25%;
    display: inline-block;
  }
}

.search_college {
  .tabs {
    color: #666666;
    letter-spacing: 2px;
    border: 1px solid #dfdfdf;
    padding: 15px;

    .title {
      font-size: 18px;
      color: #333333;
      font-weight: 500;
      text-align: center;
    }

    span {
      display: inline-block;
      padding: 0 12px;
      line-height: 27px;
      margin-bottom: 3px;

      &:hover {
        background: #2b7bf3;
        color: white;
      }
    }
  }
}

.act {
  background-color: #2b7bf3;
  color: #ffffff;
}
</style>
